"use client";

import { usePathname } from "next/navigation";

import { usePlatformAuth } from "@/hooks/use-platform-auth";
import {
  resolvePricingDestination,
  type PricingDestination,
} from "@/lib/platform/pricing-destination";

export function usePricingDestination(): PricingDestination {
  const pathname = usePathname();
  const { isAuthenticated } = usePlatformAuth();

  return resolvePricingDestination({
    isAuthenticated,
    pathname,
  });
}
